<script setup>
import { ElCollapseItem, ElIcon, ElOption, ElSelect, ElPagination, ElButton,ElDrawer, ElNotification } from 'element-plus';
import { ArrowRightBold,EditPen, Delete,CloseBold } from '@element-plus/icons-vue'
import { storeToRefs } from 'pinia';
import { useProductStore } from '../../stores/fpe'; 
import { onMounted, ref, computed, reactive, watch, defineEmits, defineProps } from 'vue';
import VueResizable from 'vue-resizable'
import variationGeneral from './variation-panel/variation-general.vue';
import variationPrice from './variation-panel/variation-price.vue';
import variationInventory from './variation-panel/variation-inventory.vue';
import variationShipping from './variation-panel/variation-shipping.vue';
import variationDownload from './variation-panel/variation-download.vue';
import variationAttributes from './variation-panel/variation-attributes.vue';

const store = useProductStore();
const { strings, product, data_sets,addSelectedVariation, selectedVariation, getVariationDetails, isLoading, notice, isNewVariation } = storeToRefs(store);
const visible = ref(false);
const props = defineProps({
    variationID: {
        type: [Number, String],
        default: null
    },
    visible: {
        type: Boolean,
        default: false
    },
    variationData: {
        type: Object,
        default: null,
    }
});
const variationData = ref(props.variationData);
const emits = defineEmits(['close']);
const activeTab = ref('attributes');
const handleChange = (val) => {
    activeTab.value = val;
}
const handleSave = () => {
    if(store.isNewVariation) {
        
        store.createVariation();
    } else {
        
        store.updateVariation();
    }
}

</script>
<template>

    <div class="fpe-variation-panel-content resizable-content">
        
        <div class="fpe-variation-panel-header ">
            <div class="fpe-variation-header-img" v-if="props.variationData?.image_src">
                <img :src="props.variationData.image_src" alt="Product Image" />
            </div>
            <div class="fpe-variation-header-details">
                <h5 class="product-id">{{ isNewVariation ? 'Add New Variation' : `Edit Variation - #${props.variationData?.id}` }}</h5>
                <span v-if="props.variationData?.attributes">
                {{ 
                    Object.values(props.variationData.attributes).filter(v => v).join(" . ") 
                }}
                </span>
            </div>
            <el-icon @click="emits('close')" class="fpe-variation-panel-close"><CloseBold /></el-icon>
        </div>
        <div class="fpe-variation-details resizable-body">
            <el-collapse v-model="activeTab" @change="handleChange" accordion >
                <variation-attributes/>
                <variation-general :variationData="props.variationData" />
                <variation-price />                      
                <variation-inventory />         
                <variation-shipping />
                <variation-download />             
            </el-collapse>
        </div>
        <div class="fpe-variation-panel-footer">
            <el-button @click="emits('close')" class="fpe-cancel">Cancel</el-button>
            <el-button type="primary" @click="handleSave" :loading="isLoading">{{ isNewVariation ? 'Add Variation' : 'Update' }}</el-button>
        </div>    
</div>
    
</template>
<style>
    .resizable-content{
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .resizable-body{
        overflow-y: auto;
        flex:1;
    }
</style>